import { Box, Divider as UclDivider } from '@rbilabs/universal-components';

export const Divider = UclDivider.withConfig({
  marginY: '$4',
  orientation: 'horizontal',
  thickness: '1',
});

export const NeedHelpButtonLoadingIndicatorWrapper = Box.withConfig({
  padding: '$3',
  borderWidth: 1,
  borderColor: 'transparent',
});
